import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
//i18n
import { withNamespaces } from "react-i18next";
import moment from "moment";
import { getLink } from "../../../routes/getNotificationRoute";

const NotificationDropdown = (props) => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false);
  const role = localStorage.getItem("role");
  const store_type = localStorage.getItem("store_type");

  
  return (
    <>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="dropdown d-inline-block"
        tag="li"
      >
        <DropdownToggle
          className="btn header-item noti-icon waves-effect"
          tag="button"
          id="page-header-notifications-dropdown"
        >
          <i
            className={
              props.data && props.data.unread_notifications === 0
                ? "bx bx-bell"
                : "bx bx-bell bx-tada"
            }
            onClick={props.setNotificationsRead}
          ></i>
          <span className="badge badge-danger badge-pill">
            {props.data && props.data.unread_notifications === 0
              ? ""
              : props.data.unread_notifications}
          </span>
        </DropdownToggle>

        <DropdownMenu className="dropdown-menu dropdown-menu-lg p-0" right>
          <div className="p-3">
            <Row className="align-items-center">
              <Col>
                <h6 className="m-0"> {props.t("Notifications")} </h6>
              </Col>
              {/* {props.data.notifications &&
              props.data.notifications.length > 0 ? (
                <div className="col-auto">
                  <a href="#!" className="small">
                    {" "}
                    View All
                  </a>
                </div>
              ) : null} */}
            </Row>
          </div>
          {props.data.notifications && props.data.notifications.length > 0 ? (
            <>
              <SimpleBar style={{ height: "230px" }}>
                {props.data.notifications &&
                  props.data.notifications.map((notification) => {
                    return (
                      <Link
                        to={() => {
                          return getLink(notification.action,role,store_type);
                        }}
                        className="text-reset notification-item"
                      >
                        <div className="media">
                          <div className="avatar-xs mr-3">
                            <span className="avatar-title bg-primary rounded-circle font-size-16">
                              <i className="bx bx-cart"></i>
                            </span>
                          </div>
                          <div className="media-body">
                            <h6 className="mt-0 mb-1">{notification.title}</h6>
                            <div className="font-size-12 text-muted">
                              <p className="mb-1">{notification.body}</p>
                              <p className="mb-0">
                                <i className="mdi mdi-clock-outline"></i>{" "}
                                {moment(notification.createdAt).fromNow()}{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      </Link>
                    );
                  })}
              </SimpleBar>

              <div className="p-2 border-top d-grid text-center">
                <Link
                  className="btn btn-sm btn-link font-size-14 text-center"
                  to="/notifications"
                >
                  <i className="mdi mdi-arrow-right-circle me-1"></i>{" "}
                  <span key="t-view-more">{props.t("View All")}</span>
                </Link>
              </div>
            </>
          ) : (
            <SimpleBar style={{ height: "80px" }}>
              <Link to="" className="text-reset notification-item">
                <div className="media">
                  <div className="media-body">
                    <h6 className="mt-0 mb-1"></h6>
                    <div className="font-size-12 text-muted">
                      <p className="mb-1">There are no notifications.</p>
                    </div>
                  </div>
                </div>
              </Link>
            </SimpleBar>
          )}
        </DropdownMenu>
      </Dropdown>
    </>
  );
};

export default withNamespaces()(NotificationDropdown);
